
import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
 

@Component({
  selector: 'app-invalid-link',
  templateUrl: './invalid-link.component.html',
  styleUrls: ['./invalid-link.component.css']

})


export class InvalidLinkComponent  {
    defaultLanguage :string;
    displayForgotPassword :boolean =false;
    displayforgotpass : boolean;
    
    constructor(private translate: TranslateService,
      private _router: Router,) {
    }
    ngOnInit() {

        this.defaultLanguage = sessionStorage.getItem("currentlang");
}
changeLanguage() {

    if (this.translate.currentLang == 'FR') {
      this.defaultLanguage = "NL";
      
      sessionStorage.setItem("currentlang", "NL")
      sessionStorage.setItem("presentLang", "Even geduld, we zijn uw gegevens aan het laden");
      document.getElementById('languageDropdown').innerHTML = 'FR';
      (<HTMLImageElement>document.getElementById("langlogo")).src = 'assets/Logos/logo-NL.svg';
    } else {
      this.defaultLanguage = "FR";
       
      sessionStorage.setItem("currentlang", "FR")
      sessionStorage.setItem("presentLang", "Veuillez patienter  svp, nous chargeons vos données");
      document.getElementById('languageDropdown').innerHTML = 'NL';
      (<HTMLImageElement>document.getElementById("langlogo")).src = 'assets/Logos/logo-FR.svg';
    }
    this.switchLang(this.defaultLanguage);
  }
  switchLang(lang: string) {
    this.defaultLanguage = lang;
    this.translate.use(lang);
  }
  Forgotpassword()
  {
    sessionStorage.setItem("ShowForgotPass", "true");
    this._router.navigate(['login/app-authentication']);

  }
}